import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckIcon, Loader2, BedDouble, Home } from 'lucide-react';
export function RsvpForm() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    guests: '1',
    dietary: '',
    accommodation: false
  });
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    await new Promise(resolve => setTimeout(resolve, 1500));
    setIsSubmitting(false);
    setIsSuccess(true);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const value = e.target.type === 'checkbox' ? (e.target as HTMLInputElement).checked : e.target.value;
    setFormData(prev => ({
      ...prev,
      [e.target.name]: value
    }));
  };
  return <div className="w-full max-w-lg mx-auto relative" data-id="element-81">
      <AnimatePresence mode="wait" data-id="element-82">
        {isSuccess ? <motion.div key="success" initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0
      }} className="bg-[#FDFBF7] p-12 rounded-[2rem] shadow-xl text-center border border-[#D4735E]/20 relative overflow-hidden aspect-square flex flex-col items-center justify-center" style={{
        boxShadow: '0 20px 40px -10px rgba(212, 115, 94, 0.15)'
      }} data-id="element-83">
            {/* Sun rays animation */}
            <motion.div className="absolute inset-0 flex items-center justify-center opacity-10" animate={{
          rotate: 360
        }} transition={{
          duration: 20,
          repeat: Infinity,
          ease: 'linear'
        }} data-id="element-84">
              {[...Array(8)].map((_, i) => <div key={i} className="absolute w-full h-8 bg-[#D4735E]" style={{
            rotate: `${i * 45}deg`
          }} data-id="element-85" />)}
            </motion.div>

            <motion.div initial={{
          scale: 0
        }} animate={{
          scale: 1
        }} transition={{
          type: 'spring',
          stiffness: 200,
          damping: 15
        }} className="w-20 h-20 bg-[#D4735E] rounded-full flex items-center justify-center mb-6 text-white z-10 shadow-lg" data-id="element-86">
              <CheckIcon size={40} data-id="element-87" />
            </motion.div>

            <h3 className="text-3xl font-serif text-[#D4735E] mb-3 z-10" data-id="element-88">
              Grazie!
            </h3>
            <p className="text-[#7C8B5F] z-10 font-medium" data-id="element-89">
              We look forward to seeing you in the sun.
            </p>
          </motion.div> : <motion.form key="form" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0,
        y: -20
      }} onSubmit={handleSubmit} className="bg-[#FDFBF7] p-8 md:p-12 rounded-[2rem] shadow-xl border border-[#F5E6D3] space-y-8 relative" style={{
        boxShadow: '0 20px 40px -10px rgba(74, 144, 226, 0.1)',
        borderRadius: '30px 20px 30px 20px'
      }} data-id="element-90">
            {/* Stucco texture overlay */}
            <div className="absolute inset-0 opacity-30 pointer-events-none rounded-[2rem] bg-[url('https://www.transparenttextures.com/patterns/concrete-wall.png')]" data-id="element-91"></div>

            <div className="relative z-10 space-y-6" data-id="element-92">
              <div data-id="element-93">
                <label htmlFor="name" className="block text-sm font-bold text-[#D4735E] mb-2 uppercase tracking-widest" style={{
              color: "#7E2625"
            }} data-id="element-94">
                  Full Name
                </label>
                <input type="text" id="name" name="name" required value={formData.name} onChange={handleChange} className="w-full px-5 py-4 bg-white border-2 border-[#F5E6D3] rounded-xl focus:ring-0 focus:border-[#D4735E] transition-colors outline-none text-[#555] placeholder-[#aaa]" placeholder="Guest Name" data-id="element-95" />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-96">
                <div data-id="element-97">
                  <label htmlFor="email" className="block text-sm font-bold text-[#D4735E] mb-2 uppercase tracking-widest" style={{
                color: "#7E2625"
              }} data-id="element-98">
                    Email
                  </label>
                  <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="w-full px-5 py-4 bg-white border-2 border-[#F5E6D3] rounded-xl focus:ring-0 focus:border-[#D4735E] transition-colors outline-none text-[#555]" placeholder="email@example.com" data-id="element-99" />
                </div>
                <div data-id="element-100">
                  <label htmlFor="guests" className="block text-sm font-bold text-[#D4735E] mb-2 uppercase tracking-widest" style={{
                color: "#7E2625"
              }} data-id="element-101">
                    Guests
                  </label>
                  <div className="relative" data-id="element-102">
                    <select id="guests" name="guests" value={formData.guests} onChange={handleChange} className="w-full px-5 py-4 bg-white border-2 border-[#F5E6D3] rounded-xl focus:ring-0 focus:border-[#D4735E] transition-colors outline-none appearance-none text-[#555]" data-id="element-103">
                      {[1, 2, 3, 4, 5].map(num => <option key={num} value={num} data-id="element-104">
                          {num}
                        </option>)}
                    </select>
                    <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none text-[#D4735E]" data-id="element-105">
                      <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-106">
                        <path d="M1 1L6 6L11 1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-107" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>

              {/* Accommodation Toggle */}
              <div className="bg-[#F5E6D3]/30 p-5 rounded-xl border border-[#F5E6D3] flex items-center justify-between cursor-pointer group" onClick={() => setFormData(prev => ({
            ...prev,
            accommodation: !prev.accommodation
          }))} data-id="element-108">
                <div className="flex items-center gap-3" data-id="element-109">
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center transition-colors ${formData.accommodation ? 'bg-[#D4735E] text-white' : 'bg-[#FDFBF7] text-[#D4735E]'}`} data-id="element-110">
                    {formData.accommodation ? <BedDouble size={20} data-id="element-111" /> : <Home size={20} data-id="element-112" />}
                  </div>
                  <div data-id="element-113">
                    <span className="block font-medium text-[#555]" style={{
                  color: "#7E2625"
                }} data-id="element-114">
                      Accommodation Needed?
                    </span>
                    <span className="text-xs text-[#7C8B5F]" style={{
                  color: "#555555"
                }} data-id="element-115">
                      We'll help coordinate your stay
                    </span>
                  </div>
                </div>
                <div className={`w-12 h-7 rounded-full p-1 transition-colors duration-300 ${formData.accommodation ? 'bg-[#D4735E]' : 'bg-[#ccc]'}`} data-id="element-116">
                  <div className={`w-5 h-5 bg-white rounded-full shadow-sm transition-transform duration-300 ${formData.accommodation ? 'translate-x-5' : 'translate-x-0'}`} data-id="element-117" />
                </div>
              </div>

              <div data-id="element-118">
                <label htmlFor="dietary" className="block text-sm font-bold text-[#D4735E] mb-2 uppercase tracking-widest" style={{
              color: "#7E2625"
            }} data-id="element-119">
                  Dietary Notes
                </label>
                <textarea id="dietary" name="dietary" rows={3} value={formData.dietary} onChange={handleChange} className="w-full px-5 py-4 bg-white border-2 border-[#F5E6D3] rounded-xl focus:ring-0 focus:border-[#D4735E] transition-colors outline-none resize-none text-[#555]" placeholder="Any allergies or preferences..." data-id="element-120" />
              </div>
            </div>

            <motion.button whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} disabled={isSubmitting} className="w-full py-5 bg-[#D4735E] text-white font-serif text-xl rounded-xl shadow-lg hover:shadow-xl hover:bg-[#c06350] transition-all flex items-center justify-center gap-3 disabled:opacity-70 disabled:cursor-not-allowed relative overflow-hidden group" style={{
          backgroundColor: "#7E2625"
        }} data-id="element-121">
              {isSubmitting ? <>
                  <Loader2 className="animate-spin h-5 w-5" data-id="element-122" />
                  <span data-id="element-123">Sending...</span>
                </> : <>
                  <span className="relative z-10" data-id="element-124">Confirm Attendance</span>
                  <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300" data-id="element-125"></div>
                </>}
            </motion.button>
          </motion.form>}
      </AnimatePresence>
    </div>;
}